<template>
    <div class="card">
        <div class="card-header card-header-icon card-header-rose">
            <div class="card-icon">
                <i class="material-icons">find_in_page</i>
            </div>
            <h4 class="card-title ">Histórico</h4>
        </div>
        <div class="card-body">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Usuário</th>
                            <th>Data e Hora</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-show="histories.length > 0"
                            v-for="iterator in histories"
                            :key="iterator.id">
                            <td>{{ iterator.user.name }}</td>
                            <td>{{ iterator.created_at | moment("DD/MM/YYYY") }} às {{ iterator.created_at | moment("HH:mm") }}</td>
                            <td 
                                v-html="iterator.modifications"></td>
                        </tr>
                        <tr v-show="histories.length==0">
                            <td colspan="7">Nenhum histórico encontrado!</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        histories() {
            if (this.$store.state.after_sales.item && this.$store.state.after_sales.item.after_sale_histories && this.$store.state.after_sales.item.after_sale_histories.length > 0) {
                console.log(this.$store.state.after_sales.item.after_sale_histories)
                return this.$store.state.after_sales.item.after_sale_histories;
            }
            return [];
        }
    },
    created() {
        this.getAfterSale();
    },
    methods: {
        sairModal() {
            this.$root.$emit("updateList");
            this.$root.$emit("hideModal");
        },
        async getAfterSale() {
            this.$root.$emit("onLoading");

            await this.$store.dispatch(
                "after_sales/get",
                this.$route.params.id
            );

            this.$root.$emit("onLoading");
        },
    }
};
</script>